import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { createTeeshotAxiosInstance } from "src/http";
import { recoilStates } from "src/recoil/recoilStates";
import { getAge } from "src/utils";

export default function useAuth() {
  const [isLoading, setIsLoading] = useState(false);
  const [isInvalidUser, setIsInvalidUser] = useState(false);

  const [user, setUser] = useRecoilState(recoilStates.user);

  const { search } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const isDev = process.env.NODE_ENV == "development";
    const params = new URLSearchParams(search);
    const initialToken = isDev
      ? params.get("token") || process.env.REACT_APP_TEST_TOKEN
      : params.get("token") ?? "";
    const storedToken = localStorage.getItem("auth-token") ?? "";
    const tokenToSend = initialToken ? initialToken : storedToken;
    const joinParam = params.get("join");
    localStorage.setItem("auth-token", tokenToSend);
    // 주소창에서 token 파라미터만 제거 (join=sbs는 유지)
    if (params.has("token")) {
      params.delete("token");
      const newQuery = params.toString();
      const newUrl = `${window.location.pathname}${newQuery ? `?${newQuery}` : ""}${window.location.hash || ""}`;
      window.history.replaceState({}, "", newUrl);
    }

    (async () => {
      setIsLoading(true);
      try {
        // const res = await createTeeshotAxiosInstance().post(`/authToken?token=${tokenToSend}`);
        const res = await createTeeshotAxiosInstance().post(`/authToken`);
        if (!res?.data?.user) {
          setIsInvalidUser(true);
          return;
        }
        // localStorage.setItem("auth-token", tokenToSend);
        if (res.data?.user?.profile?.dob) {
          const age = getAge(new Date(res.data.user?.profile?.dob));
          res.data.user.age = age;
        }
        setUser(res.data.user);
        // join=sbs 파라미터가 있는 경우 외부 페이지로 id와 token을 GET으로 전달
        if (joinParam === "sbs") {
          const userId = res.data?.user?.id;
          const userName = res.data?.user?.realname;
          if (userId && tokenToSend) {
            try {
              const apiRes = await fetch(`${process.env.REACT_APP_TEESHOT_SERVER_URL}/yearbooking/join`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: String(userId), name: String(userName ?? ""), token: tokenToSend }),
              });
              if (apiRes.ok) {
                console.log("[join] success");
              } else {
                console.log("[join] failed", apiRes.status);
              }
            } catch (e) {
              console.log("[join] error", e);
            }
          }
        }
        // navigate("/");
      } catch (e) {
        setIsInvalidUser(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return { user, isLoading, isInvalidUser };
}
